export default __webpack_public_path__ + "static/media/login-img.d30e95fd.png";